import { Timestamp } from 'firebase/firestore';

export interface User {
	firstName: string;
	lastName: string;
	email: string;
	isActive: boolean;
	createdAt: Timestamp;
	lastAccessed: Timestamp;
	isEmailVerified: boolean;
	role: UserRole;
	clientIds?: string[];
	isInternal?: boolean;
}

export enum UserRole {
	ADMIN = 'ADMIN',
	USER = 'USER',
}

export interface UserClaims {
	isInternal: boolean;
	role: UserRole;
	clientIds?: string[];
}
